import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Results = lazy(() => import('../../container/results'));

const ResultRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/results`} component={Results}/>
        </Switch>
    );
};

export default ResultRoutes;